module.exports = __webpack_public_path__ + "static/media/markerActive.27ecee69.png";